module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chartContainer"
  }, [(_vm.heading) ? _c('h2', [_vm._v(_vm._s(_vm.heading))]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "chart-image",
    style: (_vm.imageStyle),
    attrs: {
      "src": _vm.base64Image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "chart"
  }, [_c('div', [(_vm.chartData) ? _c(_vm.chartType, {
    tag: "component",
    attrs: {
      "chartData": _vm.chartData,
      "height": _vm.settings.style.height * 4,
      "settings": _vm.settings,
      "width": _vm.settings.style.width * 4
    },
    on: {
      "generateChartImage": _vm.updateChartImage
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e0ea39c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chart/ChartContainer.vue
// module id = 669
// module chunks = 0